module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAANlBMVEXAJyzAJizCJi3BJy3////ENDrprrHz1tfYeHzMT1TIQkf78fHxzM7rur3impzhmJvchYjQXWHqEhUAAAAAA3RSTlPg0FC5x4CVAAAAZklEQVQoz63SSQrAIBAFUYfWxMy5/2VDoKQR251/WQ9cqC74aMwF56I5T+83BdLzmpAWka1C2wGjrxyVSt9/SLvktgNFBKFXiBmhKyB0hSp0hSp0BYSuwA6Ry77E857/HsBA/PD7fCKtB8hpQPtnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/71.png
// module id = PODX
// module chunks = 1